var _defs, _path, _line, _line2, _line3, _line4, _line5, _circle, _circle2, _line6, _line7, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-3{stroke:#0090b9;stroke-miterlimit:10;}.cls-1,.cls-2,.cls-3{stroke-width:2px;}.cls-2{fill:none;stroke:#b3ddee;stroke-linecap:round;stroke-linejoin:round;}.cls-3{fill:#b3ddee;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.63,44V97a4.49,4.49,0,0,1-4.35,4.62H19.81A4.49,4.49,0,0,1,15.46,97V22.2a4.49,4.49,0,0,1,4.35-4.62H71a7,7,0,0,1,6.75,7.22Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25,
    y1: 41.37,
    x2: 67.53,
    y2: 41.37
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25,
    y1: 51.96,
    x2: 67.53,
    y2: 51.96
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25,
    y1: 62.54,
    x2: 67.53,
    y2: 62.54
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25,
    y1: 72.99,
    x2: 67.53,
    y2: 72.99
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25,
    y1: 83.58,
    x2: 57.23,
    y2: 83.58
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 70.22,
    cy: 57.03,
    r: 23.41
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.22,
    cy: 57.03,
    r: 18.73
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 77.63,
    y1: 48.5,
    x2: 62.26,
    y2: 47.97
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 58.86,
    y1: 52.64,
    x2: 82.6,
    y2: 53.04
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.5,73.91l.12-.08L90,77.11a.11.11,0,0,1,0,.15l-8.24,5.9a.19.19,0,0,1-.25,0l-2.3-3.22.11-.08"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.79,78.42h5.57a0,0,0,0,1,0,0v19.8a.47.47,0,0,1-.47.47H89.15a.36.36,0,0,1-.36-.36V78.42a0,0,0,0,1,0,0Z",
    transform: "translate(-34.43 69.86) rotate(-35.6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature6);
export default __webpack_public_path__ + "static/media/feature6.759ea9d0c2aff3ee32407f5f8f95d5cd.svg";
export { ForwardRef as ReactComponent };